export default {
  id: null,
  companyID: null,
  name: null,
  description: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/access/groupmodel.js